<template>
<div>
 <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Adding</div>
      <div id="admin-loader"></div>
   </div>
   <div id="admin-preloader" v-if="loading1">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
   </div>
 <div v-if="changed">
<div class="container">
  <b-modal v-model="modalShow" ok-only centered centered class="text-center text-info">
      You have added maximum products/items. Please upgrade the package to add more products/items.
    </b-modal>
    <b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info">
      Product/Item Added.
    </b-modal>
    <div class="col-sm-12 col-lg-8 m-auto">
  <el-form :model="formdata" :rules="rules" ref="formdata" label-width="200px" :label-position="labelPosition" size="medium" status-icon @submit.native.prevent >

    <h3 class="text-center text-info mt-4">Add {{this.$route.params.cat}}</h3>
   <div class="file-upload col-12 col-md-6" style="margin-top: 30px;">
  <div class="image-upload-wrap" style="height: 80px;">
    <input class="file-upload-input" type='file' @change="fileSelect1" accept=".jpg, .jpeg" />
    <div class="drag-text">
      <h6 class="pt-3 pb-1">Add main image</h6>
      <p>(maximum file size 5MB)</p>
    </div>
  </div>
  <div class="file-upload-content mx-auto text-center" :style="{display: visible1}">
    <img class="file-upload-image"  :src="formdata.imageUrl1" alt="" />
    
  </div>
</div >
    
<div style=" height: auto;" class=" mb-4">
    <div class="file-upload">

  <div class="image-upload-wrap  col-12 col-md-6 m-auto" style="height: 80px;">
    <input class="file-upload-input" type='file'  multiple @change="otherIMG" accept=".jpg, .jpeg" />
    <div class="drag-text">
      <h6 class="pt-3 pb-1">Add other images</h6>
      <p>(maximum 4 images)</p>
    </div>
  </div>
   <div class="row  ">
  <div v-for="(file , i) in imgfiles" :key="i" class="file-upload-content justify-item-center col-12 col-sm-6 col-md-3" :style="{display: visible2}">
    <div :style="{display: visible2}">
    <img class="file-upload-image" style="margin-right:0px;" :src="file" alt="your image" />
    <div class="image-title-wrap mt-2">
      <button type="button" @click="removeimg(i)" class="remove-image"><span class="image-title">Remove Image</span></button>
    </div>
    </div>
  </div>
  </div>
</div >
 
</div>

  <el-form-item label="Product Name" prop="name" >
    <el-input v-model="formdata.name" clearable style="width:220px;"></el-input>
  </el-form-item>

  <el-form-item label="Price" prop="price" >
    <el-input v-model.number="formdata.price" class="input-with-select"  style="width:220px;" clearable>
      <template slot="prepend" >RS</template>
    </el-input>
  </el-form-item>

  <el-form-item label="Discount" prop="dis" >
    <el-input placeholder="Discount" v-model.number="formdata.dis"  style="width:220px;" >
      <template slot="append" ><i class="fa fa-percent"></i></template>
    </el-input>
  </el-form-item>

  <!-- <el-form-item label="Category" prop="category">
    <el-select v-model="formdata.category" placeholder="Category">
      <el-option label="cat one" value="shanghai"></el-option>
      <el-option label="cat two" value="beijing"></el-option>
    </el-select>
  </el-form-item>

<el-form-item label="Sub Category" prop="formdata.subcategory">
    <el-select v-model="formdata.subcategory" placeholder="Sub Category">
      <el-option label="subcat one" value="shanghai"></el-option>
      <el-option label="subcat two" value="beijing"></el-option>
    </el-select>
  </el-form-item> -->

  <!-- <el-form-item label="Category" prop="category">
    <el-select v-model="category" placeholder="Category">
      <el-option v-for="(hh, category) in categoriesList" :value="category" :key="category">{{category}}</el-option>
      
    </el-select>
  </el-form-item>

<el-form-item label="Sub Category" prop="formdata.subcategory">
    <el-select  :disabled="subcategories.length == 0"
    v-model="formdata.subcategory" placeholder="Sub Category">
      <el-option v-for="formdata.subcategory in subcategories" :key="formdata.subcategory" :value="formdata.subcategory">{{formdata.subcategory}}</el-option>
      
    </el-select>
  </el-form-item> -->

   <el-form-item label="Category" prop="category">
    <el-select v-model="category" placeholder="Category">
      <el-option :value="this.$route.params.cat">{{this.$route.params.cat}}</el-option>
      
    </el-select>
  </el-form-item>

<el-form-item label="Sub Category" prop="subcategory">
    <el-select 
    v-model="formdata.subcategory" placeholder="Sub Category">
      <el-option v-for="(subcat, key) in subcategories" :key="key" :value="key">{{key}}</el-option>
      
    </el-select>
  </el-form-item>

<el-form-item label="Brand (if any)" prop="brand">
    <el-input  v-model="formdata.brand" placeholder="Brand" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Model" prop="model" v-if="this.$route.params.cat == 'Cameras'">
    <el-input  v-model="formdata.model" placeholder="Model" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Karat/Carat" prop="krat" v-if="shoptype == 'Jewelry' || shoptype == 'Gems' || shoptype == 'Jewelry Gems & Watch'">
    <el-input v-model.number="formdata.karat" class="input-with-select"  style="width:220px;" clearable>
      <template slot="prepend" >k</template>
    </el-input>
  </el-form-item>

  <el-form-item label="Metal/Stone" prop="metal" v-if="shoptype == 'Jewelry' || shoptype == 'Gems' || shoptype == 'Jewelry Gems & Watch'">
    <el-input  v-model="formdata.metal" placeholder="Metal/Stone" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Author" prop="author" v-if="shopcat == 'Books'">
    <el-input  v-model="formdata.author" placeholder="Author" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Publisher" prop="publisher" v-if="shopcat == 'Books'">
    <el-input  v-model="formdata.publisher" placeholder="Publisher" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Screen Size" prop="screensize"  v-if="formdata.subcategory == 'TV'">
    <el-input  v-model="formdata.screensize" placeholder="Screen Size"  style="width:220px;" class="input-with-select" clearable>
      <template slot="prepend" >inches</template>
    </el-input>
  </el-form-item>

  <el-form-item label="Size" prop="size" v-if="shopcat == 'Clothing & Accessories' || shopcat == 'Shoes & Footwear' || this.$route.params.cat == 'Tiles' ">
    <el-input  v-model="formdata.size" placeholder="Size" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Material" prop="material" v-if="shopcat == 'Clothing & Accessories' || shopcat == 'Shoes & Footwear' || this.$route.params.cat == 'Tiles' || shoptype == 'Watch' || shopcat == 'Bags' || shopcat == 'Furniture' || shopcat == 'Home Decor' || shopcat == 'Handicrafts' || shopcat == 'Baby Kids & Toys'">
    <el-input  v-model="formdata.material" placeholder="Material" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Color" prop="color">
     <el-input v-model="formdata.color" placeholder="Color" style="width:220px;" clearable>
    </el-input>
  </el-form-item>

  <el-form-item label="Condition" prop="cond">
    <el-select v-model="formdata.cond" placeholder="Condition">
      <el-option value="new">New</el-option> 
      <el-option value="used">Used</el-option> 
    </el-select>
  </el-form-item>

   <el-form-item label="Item Type" prop="type">
    <el-select v-model="formdata.type" placeholder="Item Type">
      <el-option value="none">None</el-option> 
      <el-option value="latest">Latest Item</el-option> 
      <el-option value="bestselling">Best Selling Item</el-option> 
    </el-select>
  </el-form-item>

  <el-form-item label="Warranty" prop="warranty">
     <el-select filterable allow-create v-model="formdata.warranty" placeholder="Warranty" style="width:220px;" clearable>
      <el-option value="No Warranty">No Warranty</el-option> 
      <el-option value="1 Months Warranty">1 Months Warranty</el-option> 
      <el-option value="3 Months Warranty">3 Months Warranty</el-option> 
      <el-option value="6 Months Warranty">6 Months Warranty</el-option>
      <el-option value="1 Year Warranty">1 Year Warranty</el-option>
      <el-option value="2 Year Warranty">2 Year Warranty</el-option>
      <el-option value="3 Year Warranty">3 Year Warranty</el-option>
      <el-option value="4 Year Warranty">4 Year Warranty</el-option>
      <el-option value="5 Year Warranty">5 Year Warranty</el-option>
      <el-option value="10 Year Warranty">10 Year Warranty</el-option>
      <el-option value="Lifetime Warranty">Lifetime Warranty</el-option>
    </el-select>
  </el-form-item>

  <!-- <button class="primary d-block" @click="pickFile" >Add Image</button>
<input type="file"  @change="fileSelect2" ref="fileInput"/>
<img :src="formdata.imageUrl"  width="360" height="240"> -->


  <el-form-item label="Product Description" prop="desc">
    <el-input type="textarea" v-model="formdata.desc"  maxlength="1000"
      :autosize="{ minRows: 2, maxRows: 4}"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm('formdata')">Add</el-button>
    <el-button @click="resetForm('formdata')">Reset</el-button>
  </el-form-item>
</el-form>
</div>
</div>
</div>
</div>
</template>

<script>  
import ImageCompressor from 'image-compressor.js';
  import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'
  export default {
      name:'commonproducts',
    data() {
      var checkprice = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('Please input the price'))
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('Please input numbers'))
          } else {
            if (value < 0) {
              callback(new Error('Price cannot be negetive'))
            } else {
              callback()
            }
          }
        }, 100)
      }

      var checkdis = (rule, value, callback) => {
        
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('Please input numbers'));
          } else {
            if (value < 0 || value > 100) {
              callback(new Error('Discount should be 0 to 100'))
            } else {
              callback()
            }
          }
        }, 100)
      }
      return {
            categoriesList: [],
            subcategories: {},
            category: '',
            tags: [],
            shops: [],
            shopcat:'',
            shoptype:'',
            cansearch: 'no',
            modalShow:false,
            modalShow2:false,
            options: [{
                value: 'Option1',
                label: 'Option1'
                }, {
                value: 'Option2',
                label: 'Option2'
                }, {
                value: 'Option3',
                label: 'Option3'
                }, {
                value: 'Option4',
                label: 'Option4'
                }, {
                value: 'Option5',
                label: 'Option5'
            }],
          visible: 'block',
		      visible1: 'none',
          visible2: 'none',
          visible3: 'none',
           imgfiles:[],
           otherimgs:[],
           maxFiles: 4,
          labelPosition: '',
           loading:false,
          loading1:false,
          changed:true,

        formdata: {
          name: '',
          price:'',
          dis: 0,
          disprice: 0,
          subcategory:'',
          brand: '',
          model:'',
          karat:'',
          metal:'',
          author:'',
          publisher:'',
          size:'',
          screensize:'',
          material:'',
          color: '',
          cond:'',
          type:'',
          warranty:'',
          desc: '',
          image: null,
          imageUrl1: "",
          imageUrl2:'',
          imageUrl3:'',
          owner:'',
          isLoggedIn: false,
          currentUser: false,
         
         
        },
        
        rules: {
          name: [
            { required: true, message: 'Please input name', trigger: 'blur' },
            { min: 3, max: 100, message: 'Length should be 3 to 100', trigger: 'blur' }
          ],
          price: [
            { validator: checkprice, trigger: 'blur' } 
          ],
          dis: [
            { validator: checkdis, trigger: 'blur' } ,
            
          ],
          category: [
            { message: 'Please select category', trigger: 'change' }
          ],
          subcategory: [
            { required: true, message: 'Please select sub category', trigger: 'change' }
          ],
          brand: [
            {   message: 'Please select brand', trigger: 'change' }
          ],
          color: [
            {  message: 'Please select picture', trigger: 'blur' }
          ],
          desc: [
            {  message: 'Please input description', trigger: 'blur' }
          ]
        }
      };
    },

    watch: {
      // category () {
      //   this.subcategories = []
      //   this.formdata.subcategory = ""
      //   if (this.category.length > 0) {
      //           this.subcategories = this.categoriesList[this.category]
      //       }

      // },
      // shops () {
      //    if(this.shops[0].shoptype == 'Fashion'){
      //     this.categoriesList = ClothingAccessories
      // }
      // if(this.shops[0].shoptype == 'Elec'){
      //     this.categoriesList = mobiles
      // }
      // }
    },

    methods: {
     pickFile() {
      this.$refs.fileInput.click();
    },
    
    fileSelect1(event) {
      console.log('event is', event)
      if(event.target.files.length > 0){
      const files = event.target.files;
      let filename = files[0].name;
      console.log('files[0].type', files[0].type)
       if(files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff'){
       alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      }else if(files[0].size > 5000200){
       alert("File " + files[0].name + " is too large!");
      }else{
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.visible = 'none'
        this.formdata.imageUrl1 = reader.result;
         this.visible1 = 'block'
      });
      reader.readAsDataURL(files[0]);
     //this.image = files[0];
     const imageCompressor = new ImageCompressor();
      imageCompressor.compress(files[0], {quality: .6, width:720, height:1340})
      .then((result) => {
        // Handle the compressed image file.
        if(result.size >= 1000000){
          const imageCompressor = new ImageCompressor();
          imageCompressor.compress(result, {quality: .5})
          .then((result) => {
         
          const fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('image is',this.image1)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);
          
          //console.log(filename) 
          console.log(result.size)
           console.log('image is',result)
      })
        }else{
           
          var fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
               
               this.image1 = fileReader.result
              
               console.log('else image is',this.image1)
          });
          fileReader.readAsDataURL(result);
          //console.log(filename) 
          console.log('else',result.size)
           console.log('ekse image is',result)
        }
      })
      
      .catch((err) => {
        // Handle the error
        console.log("error is" + err)
      })
      }
      }
    },


     otherIMG(event) {
       
          var files = event.target.files;
          console.log('files are', files)
           console.log('imgfiles.length are', this.imgfiles.length)
    if(files.length > this.maxFiles || this.imgfiles.length >= this.maxFiles || files.length+this.imgfiles.length > this.maxFiles){
       alert("You can only upload a maximum of " + this.maxFiles + " files")
       return 0;
    }else{
     for(var i=0; i < files.length; i++){
       if(files[0].type == 'image/png' || files[0].type == 'image/gif' || files[0].type == 'image/svg+xml' || files[0].type == 'image/tiff'){
       alert("File " + files[0].name + " is not type of jpeg or jpg!. You cannot upload other types of images.");
      }else if(files[i].size > 5000200){
       alert("File " + files[i].name + " is too large!");
      }else{

    var reader = new FileReader();

    reader.addEventListener("load", () => {
    //   document.getElementsByClassName('image-upload-wrap').hide();
        this.visible = 'none'
        // this.logoimg = reader.result
        this.visible2 = 'inline'
   
    });
    reader.readAsDataURL(files[i]);
    console.log('files[0]', files[i])
    const imageCompressor = new ImageCompressor();
      imageCompressor.compress(files[i], {quality: .6, width:720, height:1340 })
      .then((result) => {
        // Handle the compressed image file.
        if(result.size >= 1000000){
          const imageCompressor = new ImageCompressor();
          imageCompressor.compress(result, {quality: .5})
          .then((result) => {
           const fileReader = new FileReader();

              // This fires after the blob has been read/loaded.
              fileReader.addEventListener('load', () => {
                this.imgfiles.push(fileReader.result)
               var otherimg = fileReader.result
               this.otherimgs.push(otherimg)
               console.log('image is',this.otherimgs)
              });

              // Start reading the blob as text.
              fileReader.readAsDataURL(result);
          
          //console.log(filename) 
          console.log(result.size)
           console.log('image is',result)
           
      })
        }else{
          //  const reader = new FileReader();

          //     // This fires after the blob has been read/loaded.
          //     reader.addEventListener('loadend', (e) => {
          //       this.image2 = e.srcElement.result;
          //      console.log('else image is',this.image2)
          //     });

          //     // Start reading the blob as text.
          //     reader.readAsText(result);
          var fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
                this.imgfiles.push(fileReader.result)
               var otherimg = fileReader.result
               this.otherimgs.push(otherimg)
               console.log('else image is',this.otherimgs)
          });
          fileReader.readAsDataURL(result);
          //console.log(filename) 
          console.log('else',result.size)
           console.log('ekse image is',result)
        }
      })
      
      .catch((err) => {
        // Handle the error
        console.log("error is" + err)
      })
    }
    }
    }
  },

  removeimg(i) {
       if (i > -1) {
        this.otherimgs.splice(i, 1)
        this.imgfiles.splice(i, 1)
      }
      console.log('img files is', this.imgfiles) 
      console.log('otherimg is', this.otherimgs) 
  },

    submitForm(fdata) {
      if(this.shops[0].curProducts < this.shops[0].maxProducts){
      this.$refs[fdata].validate(valid => {
        if (valid && this.image1 != undefined) {
          
          this.loading = true
          this.changed = false
          this.backToTop()
          if(this.formdata.dis != 0){
              this.formdata.disprice = this.formdata.price
              this.formdata.price = this.formdata.price - ( this.formdata.price*this.formdata.dis/100 )
          }else if(this.formdata.dis == 0){
            this.formdata.disprice = this.formdata.price
          }
          var docID
            db
            .collection("products")
            .add({
              name: this.formdata.name,
              cat: this.category,
              subcat: this.formdata.subcategory,
              loc:this.shops[0].loc,
              sname:this.shops[0].shopname,
              dis: this.formdata.dis,
              price: this.formdata.price,
              disprice: this.formdata.disprice,
              brand: this.formdata.brand,
              color: this.formdata.color,
               cond:this.formdata.cond,
               type:this.formdata.type,
              war:this.formdata.warranty,
              desc: this.formdata.desc,
              img: this.image1,
              otherimgs: this.otherimgs,
              owner: firebase.auth().currentUser.uid,
              shopID: this.shops[0].id,
               details: {
  
                        model:this.formdata.model,
                        karat: this.formdata.karat,
                        metal:this.formdata.metal,
                        author:this.formdata.author,
                        publisher:this.formdata.publisher,
                        size:this.formdata.size,
                        screensize:this.formdata.screensize,
                        material:this.formdata.material,
               
                  }
            })
            .then(docRef => {
               docID = docRef.id;
               console.log(docID)
               console.log('docRef isss',docRef)
               if( !this.$store.state.items[this.$route.params.cat]){
                   this.$store.state.items[this.$route.params.cat] = []
                  console.log('store obj created',  this.$store.state.items[this.$route.params.cat])
                }
               this.$store.state.items[this.$route.params.cat].push({
                    id :docRef.id,
                    name: this.formdata.name,
                    category: this.category,
                    subcategory: this.formdata.subcategory,
                    price: this.formdata.price,
                    brand: this.formdata.brand,
                     //make sure to use same property name used in store.js getItems fun
                   
                  })
               console.log('# items are', this.shops[0].categories[this.category][this.formdata.subcategory])
               this.shops[0].catValues[this.category] += 1
               this.shops[0].categories[this.category][this.formdata.subcategory] += 1
               this.shops[0].curProducts += 1
               if(this.shops[0].curProducts >= 5 && this.shops[0].shopcat == 'Vehicles'){
                 this.cansearch = 'yes'
               }else if(this.shops[0].curProducts >= 15 && this.shops[0].shopcat != 'Vehicles'){
                 this.cansearch = 'yes'
               }
               console.log('# updated items are', this.shops[0].categories[this.category][this.formdata.subcategory])
                db.collection('shops').doc(this.shops[0].id).update(
                  {
                    categories: this.shops[0].categories,
                    curProducts: this.shops[0].curProducts,
                    search: this.cansearch,
                    catValues: this.shops[0].catValues

                  }
                )
                .then(doc => {
                  this.formdata = {
                      name: '',
                      price:'',
                      dis: 0,
                      disprice: 0,
                      subcategory:'',
                      brand: '',
                      model:'',
                      karat:'',
                      metal:'',
                      author:'',
                      publisher:'',
                      size:'',
                      screensize:'',
                      material:'',
                      color: '',
                      cond:'',
                      type:'',
                      warranty:'',
                      desc: '',
                      image: null,
                      imageUrl1: "",
                      imageUrl2:'',
                      imageUrl3:'',
                      owner:'',
                      isLoggedIn: false,
                      currentUser: false,
                    
                    
                    }
                  this.imgfiles= []
                  this.otherimgs = []
                  this.image1 = undefined
                   this.loading = false
                    this.changed = true
                  this.modalShow2 = true
                      console.log('doc is', doc)
                })
              return docID;
            })
            .catch(error => alert(error));
        } else {
          if(this.image1 == undefined){
            alert('Add a main image!!!')
            this.backToTop()
          }
           alert("error occured");
           this.backToTop()
          return false;
        }
      })
      }else{
        this.modalShow = true
      }
    },
    resetForm(formName) {
      console.log(formName)
      this.$refs[formName].resetFields();
      this.formdata.imageUrl1 = ''
      this.imgfiles= []
      this.otherimgs = []
      },

    //    initToTopButton: function() {
    //   $(document).bind('scroll', function() {
    //     var backToTopButton = $('.goTop');
    //     if ($(document).scrollTop() > 250) {
    //       backToTopButton.addClass('isVisible');
    //       this.isVisible = true;
    //     } else {
    //       backToTopButton.removeClass('isVisible');
    //       this.isVisible = false;
    //     }
    //   }.bind(this));
    // },
    backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },
    
    },
    
    created() {
    //  this.$nextTick(function() { 
    //      this.initToTopButton();
    //   })
    this.backToTop()
      if(screen.width > 575){
        this.labelPosition = 'right'
      }else{
        this.labelPosition = 'top'
      }
      if(firebase.auth().currentUser) {
          this.isLoggedIn = true;
          this.currentUser = firebase.auth().currentUser.email;
          
          console.log(firebase.auth().currentUser.uid)
      }

      db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'categories': doc.data().categories,
          'shopcat' : doc.data().cat,
          'shoptype' : doc.data().shoptype,
          'curProducts':doc.data().curProducts,
          'maxProducts' : doc.data().maxProducts,
          'loc':doc.data().location,
          'shopname': doc.data().name,
          'catValues':doc.data().catValues,
          'cansearch':doc.data().search
          
        }
        this.shops.push(data)
        this.shopcat = this.shops[0].shopcat
        this.shoptype = this.shops[0].shoptype
        this.category = this.$route.params.cat
        this.subcategories = this.shops[0].categories[this.$route.params.cat]
        this.cansearch = this.shops[0].cansearch
        
          console.log('this.subcategories is', this.subcategories)
      })
    })
  },
    mounted() {
       

     
      
    }
  }
</script>

<style scoped>
   @import url('~@/assets/admin/css/imgupload.css');
   @import url('~@/assets/admin/css/admin-loader.css');
   
</style>


// WEBPACK FOOTER //
// src/components/admin/commonProducts.vue